import { gameConfig } from './trusty.config';

const createAudio = (src) => {
    if (!src) return null;
    const audio = new Audio(src);
    audio.volume = gameConfig.audio.volume || 0.7;
    audio.preload = 'auto'; // Попереднє завантаження
    return audio;
};

// Створюємо аудіо-об'єкти з імпортованих шляхів
const sounds = {
    success: createAudio(gameConfig.audio.success),
    error: createAudio(gameConfig.audio.error)
};

export const playSound = (isCorrect) => {
    if (!gameConfig.audio.enabled) return;
    const audio = isCorrect ? sounds.success : sounds.error;
    if (!audio) return;

    // Скидаємо час у початок, щоб можна було швидко повторювати звуки
    audio.currentTime = 0;
    
    const playPromise = audio.play();

    if (playPromise !== undefined) {
        playPromise.catch(error => {
            // Браузер блокує звук до першої взаємодії користувача
            console.warn("[TrustyAudio] Playback blocked:", error.message);
        });
    }
};
